import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import ERPModal from "../Components/ERPModal.js";

import {
  FaUserPlus,
  FaUserEdit,
  FaCalendarCheck,
  FaAward,
  FaChalkboardTeacher,
  FaClock,
  FaBook,
  FaUserTie,
  FaFileAlt,
  FaMoneyBillWave,
  FaBell,
  FaCalendar,
  FaChartBar,
  FaUserShield,
  FaLock,
  FaMoneyCheckAlt,
  FaIdBadge,
  FaPercent,
  FaWallet,
  FaEnvelopeOpenText,
  FaChartLine,
} from "react-icons/fa";

import { COLORS } from "../constants/colors";

const AdminPanel = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [index, setIndex] = useState(0);

  const ads = [
    {
      img: "/assets/billing.jpeg",
      link: "https://softcoders.in",
    },
    {
      img: "/assets/sc.jpeg",
      link: "https://softcoders.in",
    },
    {
      img: "/assets/to1.png",
      link: "https://softcoders.in",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % ads.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  const features = [
    {
      title: "Enroll Students",
      description: "Add new students to the system quickly.",
      icon: <FaUserPlus />,
    },
    {
      title: "Update Students",
      description: "Easily manage student details and data.",
      icon: <FaUserEdit />,
    },
    {
      title: "Student Attendance",
      description: "Track student attendance effortlessly.",
      icon: <FaCalendarCheck />,
    },
    {
      title: "Certificates",
      description: "Generate student certificates easily.",
      icon: <FaAward />,
    },
    {
      title: "Class & Section",
      description: "Assign students to classes and sections.",
      icon: <FaChalkboardTeacher />,
    },
    {
      title: "Timetable Management",
      description: "Create and manage school timetables.",
      icon: <FaClock />,
    },
    {
      title: "Homework & Assignments",
      description: "Assign homework and monitor progress.",
      icon: <FaBook />,
    },
    {
      title: "Staff Enrollment",
      description: "Add and manage school staff records.",
      icon: <FaUserTie />,
    },
    {
      title: "Exam Results",
      description: "Record and publish student exam results.",
      icon: <FaFileAlt />,
    },
    {
      title: "Fee Collection",
      description: "Handle student fee payments seamlessly.",
      icon: <FaMoneyBillWave />,
    },
    {
      title: "Notifications",
      description:
        "Send important notifications to students and staff.",
      icon: <FaBell />,
    },
    {
      title: "Events & Activities",
      description: "Manage school events and activity schedules.",
      icon: <FaCalendar />,
    },
    {
      title: "Role-Based Access Control",
      description:
        "Assign roles and control access based on permissions.",
      icon: <FaUserShield />,
    },
    {
      title: "User Permissions",
      description:
        "Set granular permissions for modules and actions.",
      icon: <FaLock />,
    },
    {
      title: "Real-Time Fee Collection",
      description:
        "Collect and update student fees in real time.",
      icon: <FaMoneyCheckAlt />,
    },
    {
      title: "Unique Student Identity",
      description:
        "Automatically generate unique IDs for all students.",
      icon: <FaIdBadge />,
    },
    {
      title: "Fee Concessions",
      description:
        "Apply concessions, discounts, and scholarships effortlessly.",
      icon: <FaPercent />,
    },
    {
      title: "Advance Payments",
      description:
        "Allow advance fee payments and auto-adjust future dues.",
      icon: <FaWallet />,
    },
    {
      title: "Attendance Analytics",
      description:
        "Visualize student attendance trends using charts.",
      icon: <FaChartLine />,
    },
    {
      title: "Fee Collection Analytics",
      description:
        "Analyze fee collections and revenue reports.",
      icon: <FaChartBar />,
    },
  ];

  return (
    <>
      {/* SEO HEAD */}
      <Helmet>
        <title>
          School ERP Admin Panel Software | Gurukul ERP India
        </title>

        <meta
          name="description"
          content="Gurukul ERP Admin Panel helps schools manage admissions, attendance, fee collection, timetable, staff, exams, student records, analytics, and school administration from one powerful dashboard."
        />

        <meta
          name="keywords"
          content="
          school ERP admin panel,
          school management software,
          school ERP software India,
          admin dashboard for schools,
          attendance management system,
          fee management software,
          school automation software,
          student management system,
          online school ERP,
          school administration software,
          Gurukul ERP,
          ERP for schools,
          school dashboard software,
          school management system India,
          school fee collection software,
          attendance analytics software,
          school ERP dashboard,
          cloud based school ERP,
          school management platform,
          education ERP software
          "
        />

        <meta name="author" content="Gurukul ERP" />
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English" />
        <meta name="revisit-after" content="2 days" />

        {/* Canonical */}
        <link
          rel="canonical"
          href="https://gurukulerp.in/admin-panel"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="School ERP Admin Panel Software | Gurukul ERP"
        />

        <meta
          property="og:description"
          content="Modern school ERP admin panel for attendance, fee collection, admissions, staff management, exams, reports, and analytics."
        />

        <meta
          property="og:image"
          content="https://gurukulerp.in/assets/admin.png"
        />

        <meta
          property="og:url"
          content="https://gurukulerp.in/admin-panel"
        />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Gurukul ERP" />

        {/* Twitter SEO */}
        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content="School ERP Admin Panel Software | Gurukul ERP"
        />

        <meta
          name="twitter:description"
          content="Powerful school ERP admin panel with admissions, attendance, fee collection, timetable, reports, analytics, and staff management."
        />

        <meta
          name="twitter:image"
          content="https://gurukulerp.in/assets/admin.png"
        />

        {/* Mobile SEO */}
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        />

        <meta name="theme-color" content="#3A4163" />

        {/* Geo SEO */}
        <meta name="geo.region" content="IN-HR" />
        <meta name="geo.placename" content="Panipat, Haryana" />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            name: "Gurukul ERP Admin Panel",
            applicationCategory: "BusinessApplication",
            operatingSystem: "Web",
            url: "https://gurukulerp.in/admin-panel",
            image:
              "https://gurukulerp.in/assets/admin.png",
            description:
              "School ERP admin panel software for attendance, fee collection, admissions, timetable, exams, analytics, and complete school management.",
            brand: {
              "@type": "Brand",
              name: "Gurukul ERP",
            },
            offers: {
              "@type": "Offer",
              price: "0",
              priceCurrency: "INR",
            },
          })}
        </script>
      </Helmet>

      <div
        className="min-h-screen"
        style={{
          background: `linear-gradient(to bottom, ${COLORS.background}, ${COLORS.primaryLight})`,
          color: COLORS.textPrimary,
        }}
      >
        {/* HERO SECTION */}
        <header className="relative overflow-hidden py-24 text-center">
          <div className="absolute inset-0 bg-gradient-to-b from-[#CBE3EF]/70 via-[#EDF3FB]/60 to-[#FFFFFF]" />

          <div className="relative z-10 max-w-5xl mx-auto px-6">
            <h1 className="text-5xl md:text-6xl font-extrabold mb-6 leading-tight">
              Automate & Simplify School Management with{" "}
              <span style={{ color: COLORS.primary }}>
                Gurukul ERP
              </span>
            </h1>

            <p className="text-lg md:text-xl text-[#4B5563] max-w-3xl mx-auto mb-10 leading-relaxed">
              The all-in-one ERP system for managing
              admissions, attendance, finances, and reports
              designed for modern educational institutions.
            </p>

            <div className="flex justify-center gap-6 flex-wrap">
              <button
                onClick={() => setIsModalOpen(true)}
                style={{
                  backgroundColor: COLORS.primary,
                }}
                className="text-white px-10 py-4 rounded-xl font-semibold shadow-md hover:bg-[#3A4163] hover:scale-105 transition-transform duration-300"
              >
                Try Admin Panel Demo
              </button>
            </div>
          </div>

          <div className="absolute w-72 h-72 bg-[#5AA8D6]/20 rounded-full blur-3xl top-20 left-16"></div>
          <div className="absolute w-80 h-80 bg-[#3A4163]/10 rounded-full blur-3xl bottom-10 right-20"></div>
        </header>

        {/* ABOUT SECTION */}
        <section className="flex flex-col lg:flex-row items-center py-16 px-8">
          <div className="lg:w-1/2 flex justify-center mb-8 lg:mb-0">
            <img
              src="/assets/admin.png"
              alt="School ERP Admin Dashboard Software"
              className="rounded-2xl shadow-2xl w-4/5 transform hover:scale-105 transition-transform"
            />
          </div>

          <div className="lg:w-1/2 lg:pl-12 text-center lg:text-left">
            <h2
              className="text-3xl md:text-4xl font-bold mb-4"
              style={{ color: COLORS.textPrimary }}
            >
              About Gurukul Admin Panel
            </h2>

            <p
              className="text-lg leading-relaxed"
              style={{ color: COLORS.textSecondary }}
            >
              Gurukul ERP Admin Panel simplifies educational
              management by offering tools for student
              enrollment, attendance tracking, report
              generation, timetable management, fee
              collection, and analytics all in one seamless
              platform built for modern schools.
            </p>
          </div>
        </section>

        {/* FEATURES */}
        <section
          className="py-20"
          style={{
            background: `linear-gradient(to bottom, ${COLORS.background}, ${COLORS.primaryLight})`,
          }}
        >
          <div className="container mx-auto px-6">
            <h2
              className="text-4xl font-bold text-center mb-14"
              style={{ color: COLORS.textPrimary }}
            >
              Key Features of School ERP Admin Panel
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="group relative [perspective:1200px]"
                >
                  <div className="relative h-40 w-full transition-all duration-700 ease-out [transform-style:preserve-3d] group-hover:[transform:rotateY(180deg)]">
                    {/* FRONT */}
                    <div
                      className="absolute inset-0 rounded-2xl shadow-lg flex flex-col items-center justify-center text-white text-center p-2 [backface-visibility:hidden] transition-all duration-500"
                      style={{
                        background: `linear-gradient(145deg, ${COLORS.primary}, ${COLORS.primaryDark})`,
                      }}
                    >
                      <div className="text-2xl mb-3">
                        {feature.icon}
                      </div>

                      <h3 className="text-md font-bold">
                        {feature.title}
                      </h3>
                    </div>

                    {/* BACK */}
                    <div
                      className="absolute inset-0 rounded-2xl bg-white shadow-xl flex flex-col items-center justify-center text-center p-5 [transform:rotateY(180deg)] [backface-visibility:hidden]"
                      style={{
                        color: COLORS.textPrimary,
                      }}
                    >
                      <p className="text-md leading-relaxed font-medium">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* REQUEST DEMO */}
        <section className="mt-15 pt-10 pb-10 text-center bg-gradient-to-b from-[#CBE3EF]/20 via-[#EDF3FB]/60 to-[#FFFFFF]">
          <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-10">
            {/* ADS */}
            <div className="w-full md:w-1/3">
              <p className="text-sm text-gray-400 mb-3 text-left">
                Sponsored
              </p>

              <div className="overflow-hidden">
                <div
                  className="flex transition-transform duration-500 ease-in-out"
                  style={{
                    transform: `translateX(-${index * 100}%)`,
                  }}
                >
                  {ads.map((ad, i) => (
                    <div
                      key={i}
                      className="min-w-full flex-shrink-0"
                    >
                      <a
                        href={ad.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={ad.img}
                          alt="ERP Software Ad"
                          className="w-68 h-48 object-cover rounded-xl"
                        />
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* DEMO BOX */}
            <div className="w-full md:w-2/3">
              <div className="max-w-3xl mx-auto bg-white p-10 rounded-2xl shadow-2xl text-center">
                <div className="flex justify-center mb-6">
                  <FaEnvelopeOpenText
                    className="text-5xl"
                    style={{
                      color: COLORS.primary,
                    }}
                  />
                </div>

                <h2
                  className="text-3xl font-bold mb-4"
                  style={{
                    color: COLORS.textPrimary,
                  }}
                >
                  Request Demo Credentials
                </h2>

                <p
                  className="mb-8 text-lg"
                  style={{
                    color: COLORS.textSecondary,
                  }}
                >
                  Want to explore Gurukul ERP Admin Panel?
                  Request your demo credentials below.
                </p>

                <div className="flex flex-col md:flex-row justify-center gap-6">
                  <button
                    onClick={() =>
                      setIsModalOpen(true)
                    }
                    className="text-white px-10 py-4 rounded-lg font-semibold shadow-md transition-all"
                    style={{
                      backgroundColor: COLORS.primary,
                    }}
                  >
                    Request Demo
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* SEO CONTENT */}
        <section className="py-20 px-6 bg-white">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl font-bold mb-8 text-center">
              Why Schools Choose Gurukul ERP Admin Panel
            </h2>

            <p className="text-lg leading-9 text-gray-700 mb-6">
              Gurukul ERP is a modern school management
              software designed to automate and simplify
              daily school operations. From admissions and
              attendance to fee collection and analytics,
              schools can manage everything from one secure
              dashboard.
            </p>

            <p className="text-lg leading-9 text-gray-700 mb-6">
              The admin panel helps school administrators,
              principals, teachers, and staff manage
              academic and operational workflows efficiently.
              The platform supports attendance management,
              online fee collection, timetable management,
              student records, staff management, and exam
              reporting.
            </p>

            <p className="text-lg leading-9 text-gray-700">
              Gurukul ERP software is built for schools,
              coaching institutes, and educational
              organizations looking for a reliable cloud
              based school ERP solution in India.
            </p>
          </div>
        </section>

        {/* MODAL */}
        <ERPModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      </div>
    </>
  );
};

export default AdminPanel;